const vocationMap = [
    'No Vocation',
    'Sorcerer',
    'Druid',
    'Paladin',
    'Knight',
    'Master Sorcerer',
    'Elder Druid',
    'Royal Paladin',
    'Elite Knight'
];


export const CharacterStatsComponent = ({characterInformation}) => {
    return ( <>
        <div>
            <h4>Level</h4>
            <p>{characterInformation.level}</p>
        </div>
        <div>
            <h4>Vocation</h4>
            <p>{vocationMap[characterInformation.vocation]}</p>
        </div>
        <div>
            <h4>Health</h4>
            <p>{characterInformation.healthmax}</p>
        </div>
        <div>
            <h4>Mana</h4>
            <p>{characterInformation.manamax}</p>
        </div>
        <div>
            <h4>Constitution</h4>
            <p>{characterInformation.stat_constitution}</p>
        </div>
        <div>
            <h4>Dexterity</h4>
            <p>{characterInformation.stat_dexterity}</p>
        </div>
        <div>
            <h4>Intellect</h4>
            <p>{characterInformation.stat_intellect}</p>
        </div>
        <div>
            <h4>Spirit</h4>
            <p>{characterInformation.stat_spirit}</p>
        </div>
        <div>
            <h4>Strength</h4>
            <p>{characterInformation.stat_strength}</p>
        </div>

    </>);
};

export const CharacterSkillComponent = ({characterInformation}) => {

    return ( <>
        <div>
            <h4>Alchemy</h4>
            <p>{characterInformation.skill_alchemy}</p>
        </div>
        <div>
            <h4>Cooking</h4>
            <p>{characterInformation.skill_cooking}</p>
        </div>
        <div>
            <h4>Crafting</h4>
            <p>{characterInformation.skill_crafting}</p>
        </div>
        <div>
            <h4>Enchanting</h4>
            <p>{characterInformation.skill_enchanting}</p>
        </div>
        <div>
            <h4>Fishing</h4>
            <p>{characterInformation.skill_fishing}</p>
        </div>
        <div>
            <h4>Jewelcrafting</h4>
            <p>{characterInformation.skill_jewelcrafting}</p>
        </div>
        <div>
            <h4>Leatherworking</h4>
            <p>{characterInformation.skill_leatherworking}</p>
        </div>
        <div>
            <h4>Minning</h4>
            <p>{characterInformation.skill_minning}</p>
        </div>
        <div>
            <h4>Runecrafting</h4>
            <p>{characterInformation.skill_runecrafting}</p>
        </div>
        <div>
            <h4>Skinning</h4>
            <p>{characterInformation.skill_skinning}</p>
        </div>
        <div>
            <h4>Smithing</h4>
            <p>{characterInformation.skill_smithing}</p>
        </div>
        <div>
            <h4>Tailoring</h4>
            <p>{characterInformation.skill_tailoring}</p>
        </div>
        <div>
            <h4>Woodcutting</h4>
            <p>{characterInformation.skill_woodcutting}</p>
        </div>
    </>);
};